export default {
   // get shop data
   getShop(state) {
      return state.shop;
   },

}